// extracted by mini-css-extract-plugin
export var phone = "_2c-0";
export var phoneDragging = "_2c-1";